/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportDashboardLayoutItem } from './ReportDashboardLayoutItem';
import type { ReportFunnelStatusTimeseriesFilters } from './ReportFunnelStatusTimeseriesFilters';
import type { ReportWidgetAccentColor } from './ReportWidgetAccentColor';
import type { ReportWidgetValidation } from './ReportWidgetValidation';
/**
 * Persisted funnel first-entry time series widget instance.
 */
export type ReportFunnelStatusTimeseriesWidgetInstance = {
    /**
     * Stable widget instance identifier.
     */
    id: string;
    /**
     * Discriminator for the funnel status timeseries widget.
     */
    kind: ReportFunnelStatusTimeseriesWidgetInstance.kind;
    /**
     * Optional user-facing title override.
     */
    title?: string;
    /**
     * Optional short badge label shown on the widget card.
     */
    label?: string;
    /**
     * Optional semantic accent color used to tint the widget card and badge.
     */
    color?: ReportWidgetAccentColor;
    /**
     * Saved layout metadata for the widget instance.
     */
    layout: ReportDashboardLayoutItem;
    /**
     * Validation result resolved from the current tenant state.
     */
    validation?: ReportWidgetValidation;
    /**
     * Saved filters for the funnel status timeseries widget.
     */
    filters: ReportFunnelStatusTimeseriesFilters;
};
export namespace ReportFunnelStatusTimeseriesWidgetInstance {
    /**
     * Discriminator for the funnel status timeseries widget.
     */
    export enum kind {
        FUNNEL_STATUS_FIRST_ENTRY_TIMESERIES = 'FUNNEL_STATUS_FIRST_ENTRY_TIMESERIES',
    }
}

